import { ReportInfoInput } from '@e-socna/data-layer';
import type { ReadonlyDeep } from 'type-fest';

import { pruneInput } from '../../../utils/prune-input.util';

import type { MissionReportPage_ReportInfo } from '../fragments/report-info.fragment';

export function reportInfoForm2ApiMapper(
  reportInfo: ReadonlyDeep<MissionReportPage_ReportInfo>,
) {
  return pruneInput(reportInfo, ReportInfoInput);
}
